<template>
    <footer class="footermain">
        <div class="container">
            <div class="footer-copyright">
                <p>ⓒ Copyrights 2026 | SYNAPSE</p>
            </div>
        </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: "FooterComponent",
  };
  </script>


<style scoped>


.footermain {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: auto;
}   


</style>
  